'use client';

import React from 'react';
import {
  RefreshCcw,
  Users,
  AlertTriangle,
  Clock,
  CheckCircle,
  TrendingUp,
  TrendingDown,
  Minus,
} from 'lucide-react';

const KPI_DATA = [
  {
    id: 'kpi-active',
    label: 'Active Cycles',
    value: '6',
    delta: '2 pending closure',
    trend: 'neutral' as const,
    trendLabel: 'vs last month',
    icon: <RefreshCcw size={20} />,
    variant: 'hero' as const,
    progress: null,
  },
  {
    id: 'kpi-submission',
    label: 'Overall Submission Rate',
    value: '79%',
    delta: '+6% since last week',
    trend: 'up' as const,
    trendLabel: '+6%',
    icon: <CheckCircle size={20} />,
    variant: 'success' as const,
    progress: { value: 79, label: '247 of 312 employees' },
  },
  {
    id: 'kpi-overdue',
    label: 'Overdue Submissions',
    value: '31',
    delta: '9 escalated to managers',
    trend: 'down' as const,
    trendLabel: '+9 this week',
    icon: <AlertTriangle size={20} />,
    variant: 'danger' as const,
    progress: null,
  },
  {
    id: 'kpi-manager',
    label: 'Pending Manager Reviews',
    value: '49',
    delta: 'Across 3 active cycles',
    trend: 'down' as const,
    trendLabel: '-12 this week',
    icon: <Users size={20} />,
    variant: 'warning' as const,
    progress: null,
  },
  {
    id: 'kpi-hrqueue',
    label: 'HR Review Queue',
    value: '9',
    delta: 'Probation cycle: 9 pending',
    trend: 'neutral' as const,
    trendLabel: 'Unchanged',
    icon: <Clock size={20} />,
    variant: 'default' as const,
    progress: { value: 61, label: '14 of 23 reviewed' },
  },
  {
    id: 'kpi-completed',
    label: 'Avg Completion Rate',
    value: '64%',
    delta: 'Target: 85% by May 31',
    trend: 'up' as const,
    trendLabel: '+8% this cycle',
    icon: <TrendingUp size={20} />,
    variant: 'default' as const,
    progress: { value: 64, label: '171 of 267 forms closed' },
  },
];

const TREND_ICONS = {
  up: <TrendingUp size={12} />,
  down: <TrendingDown size={12} />,
  neutral: <Minus size={12} />,
};

export default function DashboardKPIs() {
  return (
    <div className="pn-appraisal__kpi-grid">
      {KPI_DATA.map((kpi) => (
        <div
          key={kpi.id}
          className={`pn-appraisal__kpi-card${kpi.variant === 'hero' ? ' pn-appraisal__kpi-card--hero' : kpi.variant === 'danger' ? ' pn-appraisal__kpi-card--danger' : kpi.variant === 'warning' ? ' pn-appraisal__kpi-card--warning' : kpi.variant === 'success' ? ' pn-appraisal__kpi-card--success' : ''}`}
        >
          <div className="pn-appraisal__kpi-card-header">
            <div className="pn-appraisal__kpi-card-icon-wrap">{kpi.icon}</div>
            <div className={`pn-appraisal__kpi-card-trend pn-appraisal__kpi-card-trend--${kpi.trend}`}>
              {TREND_ICONS[kpi.trend]}
              {kpi.trendLabel}
            </div>
          </div>
          <div className="pn-appraisal__kpi-card-value">{kpi.value}</div>
          <div className="pn-appraisal__kpi-card-label">{kpi.label}</div>
          <div className="pn-appraisal__kpi-card-delta">{kpi.delta}</div>
          {kpi.progress && (
            <div className="pn-appraisal__kpi-card-progress">
              <div className="pn-appraisal__kpi-card-progress-bar">
                <div
                  className={`pn-appraisal__kpi-card-progress-bar-fill${kpi.progress.value >= 80 ? ' pn-appraisal__progress-bar-fill--high' : kpi.progress.value >= 60 ? '' : ' pn-appraisal__progress-bar-fill--low'}`}
                  style={{ width: `${kpi.progress.value}%` }}
                />
              </div>
              <div className="pn-appraisal__kpi-card-progress-label">
                <span>{kpi.progress.label}</span>
                <span>{kpi.progress.value}%</span>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}